import React, { useEffect } from "react";
import { Modal, Button, Input, Form } from "antd";
import DigitalCoinTrait from "$ACTIONS/trait/DigitalCoinTrait";
import DigitalcoinUtil from '$ACTIONS/DigitalcoinUtil';
const { Item } = Form;

function AddDigitalCoinWalletAddress(props) { // copy from AddWalletAddress then modify
    const {
        aryAddedDigitalCoin,
        visibleDigitalCoinWallet,
        leaveAddWallet,
        digitalCoinWalletRegExpTest,
        handleOk,
        addTDBBtnStatue,
        digitalcoinMethod,
        meAt,
        tDBName,
        tDBAddress,
        tDBAddressError,
        tDBAddressError2,
    } = props;
    const onChangeFunc = val => digitalCoinWalletRegExpTest(val, 'cointype');
    const _DigitalCoinTrait = DigitalCoinTrait(this, false);
    const calculateAry = aryAddedDigitalCoin => {
    let ary = Object.keys(DigitalcoinUtil.WALLET_REGEXP_MAP); // default: get all coins
    if (aryAddedDigitalCoin?.length) {
        let excludeAry = aryAddedDigitalCoin.map(v=>v.cryptocurrency)
        ary = ary.filter(v=>!excludeAry.includes(v));
    }
    return ary;
    } // end of calculateAry
    let ary = calculateAry(aryAddedDigitalCoin);
    useEffect(() => {
        console.log('0430 aaaaaa useEffect aryAddedDigitalCoin', aryAddedDigitalCoin);
        let ary = calculateAry(aryAddedDigitalCoin);
        if (ary?.length===1) { onChangeFunc(ary[0]); }
    }, [aryAddedDigitalCoin]);
    return (
        <Modal
            title={"添加代币钱包地址"}
            visible={visibleDigitalCoinWallet}
            onCancel={leaveAddWallet}
            footer={null}
            className="addExchangeRateWalletModal"
            width={400}
        >
            <Form className="WalletModal-form-wrap">
                <Item label="代币钱包">
                    {_DigitalCoinTrait.renderSelect(ary, tDBName, {useHardCode:true, onChangeFunc, meAt})}
                </Item>
                <Item label="钱包地址">
                    <Input
                        size="large"
                        className="tlc-input-disabled"
                        placeholder="请输入钱包地址"
                        onChange={(e) =>
                            digitalCoinWalletRegExpTest(
                                e,
                                "address", {curCoinType:tDBName})
                        }
                        maxLength={DigitalcoinUtil.getMaxAddressLengthByCoinType(tDBName)}
                        value={tDBAddress}
                    />
                    {tDBName && <div style={{background:'#EFEFF4', padding:'8px 16px', borderRadius:8,marginTop:8}}><div className="modal-wallet-info" style={{fontSize:12}}>
                        <img
                            style={{ marginRight: "0.4rem" }}
                            src={`/cn/img/icon/${
                                !tDBAddressError2 ? "greyTick" : "greenTick"
                            }.svg`}
                        />
                        不允许使用空格和特殊字符
                    </div>
                    <div className="modal-wallet-info" style={{fontSize:12}}>
                        <img
                            style={{ marginRight: "0.4rem" }}
                            src={`/cn/img/icon/${
                                !tDBAddressError ? "greyTick" : "greenTick"
                            }.svg`}
                        />
                        {DigitalcoinUtil.getAddressHintByCoinType(tDBName)}
                    </div></div>}
                </Item>
                <Item>
                    <div className="btn-wrap">
                        {/* <Button size="large" htmlType="submit" block onClick={leaveAddWallet}>取消</Button> */}
                        <Button
                            size="large"
                            htmlType="submit"
                            block
                            onClick={handleOk}
                            disabled={!addTDBBtnStatue}
                            className={`${addTDBBtnStatue ? "active" : ""}`}
                        >
                            提交
                        </Button>
                    </div>
                </Item>
            </Form>
        </Modal>
    );
}

export default AddDigitalCoinWalletAddress;
